import axiosInstance from './rootApi';

/**
 * Generic GET request.
 * @param {string} endpoint - e.g. '/products' or '/products/123'
 * @returns {Promise<any>} - response data
 */
const getApi = async (endpoint) => {
  const response = await axiosInstance.get(endpoint);
  return response.data;
};

export default getApi;
